// 担当運営者(DA)のエンティティ
export class DaCourseOperator {
  // コース担当者ID DB型(*autokey)
  public course_operator_id?: number;
  // 先生ユーザーID DB型(*fk)
  public teacher_user_id?: string;
  // 担当運営者ユーザーID DB型(*fk)
  public operator_user_id?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): DaCourseOperator {
    const entity = new DaCourseOperator();
    entity.course_operator_id = record['course_operator_id'];
    entity.teacher_user_id = record['teacher_user_id'];
    entity.operator_user_id = record['operator_user_id'];
    return entity;
  }
  static getTypeFitEntity(value: any): DaCourseOperator {
    const entity = new DaCourseOperator();
    entity.course_operator_id = value.course_operator_id;
    entity.teacher_user_id = value.teacher_user_id;
    entity.operator_user_id = value.operator_user_id;
    return entity;
  }
}
